import { render, staticRenderFns } from "./ratingForm.vue?vue&type=template&id=1b1fb013&"
import script from "./ratingForm.vue?vue&type=script&lang=js&"
export * from "./ratingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports